// src/components/BarrioSection.js
import React from "react";
import "./BarrioSection.css";
import planoImage from "../assets/mmapa.png";

const BarrioSection = () => {
  return (
    <section className="barrio-section">
      {/* Title Section */}
      <div className="barrio-title-container">
        <h2 className="barrio-title">El Barrio</h2>
      </div>

      <div className="title-divider"></div>

      {/* Content Section */}
      <div className="barrio-content">
        <div className="barrio-text">
          <p className="barrio-paragraph">
            <span className="bold">Patraix</span> combina el carácter de un
            barrio
            <br />
            tradicional con todas las comodidades de
            <br />
            la vida moderna.
          </p>

          <p className="barrio-paragraph">
            Calles tranquilas y una vibrante vida
            <br />
            comunitaria crean un entorno único,
            <br />
            donde conviven mercados, pequeños
            <br />
            comercios, parques, hospitales y colegios.
          </p>

          <p className="barrio-paragraph">
            Cuenta con dos estaciones de metro y una
            <br />
            amplia red de autobuses que garantizan
            <br />
            un acceso rápido a las playas, el puerto y<br />
            otros puntos clave de la ciudad.
          </p>
        </div>

        <div className="barrio-image">
          <img src={planoImage} alt="Plano del barrio" className="plano-img" />
        </div>
      </div>
    </section>
  );
};

export default BarrioSection;
